import {FETCH_TESTIMONIES} from './types';
import salomapi from '../apis';


export const fetchTestimonies = () => async dispach => {
    const response = await salomapi.get('/swprayer/testimonies');
    dispach({type:FETCH_TESTIMONIES,payload:response.data})
}